import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import TabButton from "../../../../../../../Components/common/TabButton/TabButton";
import NotificationHeader from "../../NotificationHeader";
import Field from "../../../../Components/Field";
import Spinner from "../../../../../../../Components/common/Spinner/Spinner";
import Backdrop from "../../../../../../../Components/UI/Backdrop/Backdrop";
import Warning from "../../../../../../../Components/common/Warning/Warning";

import {
  requestDeleteSyslogConfig,
  requestGetSyslogConfig,
  requestSetSyslogConfig,
  RequestTestSyslogServer,
} from "../../../../../../../store/actions/settingsActions";

import "./styles.scss";

const SPINNER_SIZE = { width: 22, height: 22 };

const SyslogNotification = ({ selectedNotification }) => {
  const activeFromDB = useSelector((state) => state.settings.syslogActive);
  const serverFromDB = useSelector((state) => state.settings.syslogServer);
  const portFromDB = useSelector((state) => state.settings.syslogPort);
  const connectionFromDB = useSelector((state) => state.settings.syslogConnection);
  const syslogConfigLoading = useSelector((state) => state.settings.syslogConfigLoading);

  const testSyslogServerLoading = useSelector((state) => state.settings.testSyslogServerLoading);

  const dispatch = useDispatch();

  const [active, setActive] = useState(false);
  const [server, setServer] = useState("");
  const [port, setPort] = useState("");
  const [connection, setConnection] = useState("");
  const [showResetWarning, setShowResetWarning] = useState(false);

  useEffect(() => {
    dispatch(requestGetSyslogConfig());
  }, [dispatch]);

  useEffect(() => {
    setServer(serverFromDB);
    setPort(portFromDB);
    setConnection(connectionFromDB);
    setActive(activeFromDB);
  }, [serverFromDB, portFromDB, connectionFromDB, activeFromDB]);

  const updateSyslogHandler = () => {
    if (server === "" || port === "" || connection === "") return;
    dispatch(requestSetSyslogConfig({ server, port, connection }));
  };

  const toggleActiveStateHandler = () => {
    if (syslogConfigLoading) return;
    dispatch(requestSetSyslogConfig({ active: !active }));
  };

  // Keep the same guard on the button so the confirmation is not shown when there
  // is nothing to reset.
  const resetWarningHandler = () => {
    if (server === "" || port === "" || connection === "") return;
    setShowResetWarning(true);
  };

  const deleteSyslogHandler = () => {
    setShowResetWarning(false);
    if (server === "" || port === "" || connection === "") return;
    dispatch(requestDeleteSyslogConfig());
  };

  const testSyslogServerHandler = () => {
    if (!serverFromDB || !portFromDB || !connectionFromDB) return;
    dispatch(RequestTestSyslogServer());
  };

  return (
    <>
      <div className="button-block">
        <TabButton title="Syslog" onClick={() => {}} active="Syslog" />
      </div>
      <NotificationHeader
        selectedNotification={selectedNotification}
        toggleProps={{
          show: true,
          text: "Status",
          active: active,
          onClick: toggleActiveStateHandler,
        }}
      />
      <div className="syslog__content">
        <div className="syslog__body">
          <div className="syslog__body__content">
            <div className="syslog__body__content__row">
              <div className="syslog__body__content__row__connection-type">
                <p className="syslog__body__content__row__connection-type__header">
                  Connection Type
                </p>
                <div className="syslog__body__content__row__connection-type__labels">
                  <label className="align-items">
                    <input
                      className="syslog__body__content__row__connection-type__input"
                      type="radio"
                      value="TCP"
                      name="tcp"
                      checked={connection === "TCP"}
                      onChange={(event) => setConnection(event.target.value)}
                    />
                    <p className="margin-left-12">TCP</p>
                  </label>
                  <label className="align-items">
                    <input
                      className="syslog__body__content__row__connection-type__input"
                      type="radio"
                      value="UDP"
                      name="udp"
                      checked={connection === "UDP"}
                      onChange={(event) => setConnection(event.target.value)}
                    />
                    <p className="margin-left-12">UDP</p>
                  </label>
                </div>
              </div>
            </div>
            <div className="syslog__body__content__row">
              <Field
                label="Server"
                width="131px"
                value={server}
                onChange={(e) => setServer(e.target.value)}
              />
              <Field
                label="Port"
                onChange={(e) => setPort(e.target.value)}
                value={port}
                width="131px"
                maxLength="15"
              />
            </div>
            <div className="syslog__body__content__row">
              <button className="default-button" onClick={resetWarningHandler}>
                Reset
              </button>
              <button
                className="primary-button"
                onClick={updateSyslogHandler}
                disabled={
                  server === "" ||
                  port === "" ||
                  connection === "" ||
                  (server === serverFromDB &&
                    port === portFromDB &&
                    connection === connectionFromDB)
                }>
                {syslogConfigLoading ? (
                  <Spinner width={SPINNER_SIZE.width} height={SPINNER_SIZE.height} />
                ) : (
                  "Save"
                )}
              </button>
              <button
                className="primary-button"
                onClick={testSyslogServerHandler}
                disabled={!serverFromDB || !portFromDB || !connectionFromDB}>
                {testSyslogServerLoading ? (
                  <Spinner width={SPINNER_SIZE.width} height={SPINNER_SIZE.height} />
                ) : (
                  "Send Test Log"
                )}
              </button>
            </div>
          </div>
          <Backdrop
            spinner={false}
            absolute
            show={!active}
            message="Syslog notification is inactive! Please click on the status button to activate syslog notifications."
            messageStyle={{ paddingTop: 0 }}
          />
        </div>
      </div>
      <Warning
        onClickOk={deleteSyslogHandler}
        show={showResetWarning}
        setShow={setShowResetWarning}
        text="The syslog configuration will be deleted and reset to its default values. Do you want to continue?"
        article="Reset"
      />
    </>
  );
};

export default SyslogNotification;
